import { Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { Container, Item } from '../../Cfmp.styles'

const CfmpFormSection = ({ children, description, title }) => (
  <Container spacing={4}>
    <Item container direction="column" size={{ lg: 3, xs: 12 }} spacing={1}>
      <Typography fontWeight="bold" variant="body1">
        {title}
      </Typography>

      <Typography variant="body2">{description}</Typography>
    </Item>

    <Item size={{ lg: 9, xs: 12 }}>{children}</Item>
  </Container>
)

CfmpFormSection.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  title: PropTypes.string
}

export default CfmpFormSection
